import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-intelligentCabinet",
  "use": "icon-intelligentCabinet-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-intelligentCabinet\">\n  <path d=\"M5.5 3.5h13v17h-13v-17Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\" />\n  <path d=\"M5.5 9h13M5.5 14.5h13M12 3.5v17M8.5 6.5h.1M15.5 12h.1M8.5 17.2h.1\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol